import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import orderBy from "lodash/orderBy";
import find from "lodash/find";
import isEmpty from "lodash/isEmpty";
import isObject from "lodash/isObject";
import moment from "moment";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input, Checkbox } from "formsy-react-components";

import * as contractActions from "../../actions/contractActions";
import * as departmentActions from "../../actions/departmentActions";
import * as userActions from "../../actions/userActions";
import * as codeActions from "../../actions/codeActions";
import * as customerActions from "../../actions/customerActions";
import * as departmentCategoryActions from "../../actions/departmentCategoryActions";

import DatePicker from "../common/DatePicker";

import DropdownSearch from "../common/DropdownSearch";
import DepartmentCategorySelect from "../common/DepartmentCategorySelect";
import ProjectBudgetCalculator from "./ProjectBudgetCalculator";

import { formatDate } from "../../helpers/date";

import { SupportResources } from "../support-resources/components";
import MonthlySegmentForm from "./MonthlySegmentForm";

class ProjectForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      canSubmit: false,
      supportResources: [{ id: 1, employee: "", text: 1 }],
      budget_segments: []
    };
  }

  componentDidMount = async () => {
    const {
      departments,
      users,
      codes,
      customers,
      actions,
      contracts,
      departmentCategories
    } = this.props;
    this.loadDefaults(this.props);
    this.setState({ canSubmit: true });
    if (isEmpty(departments)) await actions.loadDepartments();
    if (isEmpty(users)) await actions.loadUsers();
    if (isEmpty(codes)) await actions.loadCodes();
    if (isEmpty(customers)) await actions.loadCustomers();
    if (isEmpty(contracts)) await actions.loadContracts();
    if (isEmpty(departmentCategories)) await actions.loadDepartmentCategories();
    this.setState({ canSubmit: false });
  };

  onChange = (field, selected) => {
    this.setState({
      [field]: Array.isArray(selected) ? selected : selected?.value || null
    });
    if (field === "contract") {
      // get contract type and use the call type with the matching label
      const contract = find(this.props.contracts, { _id: selected.value });
      const contractType = find(this.props.codes, {
        _id: contract.contract_type._id
      });
      const callType = find(this.props.codes, {
        label: contractType.label,
        entity: "Call"
      });
      this.setState({
        contract: contract._id,
        contractStart: contract.start_date,
        contractEnd: contract.end_date,
        call_type: callType._id,
        rate: contract.billing_rate,
        salesperson: contract.salesperson
      });
    } else if (field === "department") {
      this.setState({
        department_category: null
      });
    }
  };

  onChangeDate = (date, name) => {
    this.setState({
      [name]: formatDate(date, "yyyy-MM-dd"),
      dateHasChanged: true
    });
  };

  onChangeSupportResources = (resources) => {
    this.setState({ supportResources: resources });
  };

  onChangeMonthlySegments = (segments, monthlySegmentsChecked) => {
    console.log(segments, "segments in project form", monthlySegmentsChecked);
    if (segments) {
      this.setState({
        budget_segments: segments,
        monthlySegmentsChanged: true,
        monthlySegmentsChecked
      });
    } else {
      this.setState({ monthlySegmentsChecked });
    }
  };

  loadDefaults = (props) => {
    const { project, codes, adding } = props;

    if (adding) {
      const project_status = find(codes, { label: "In Process" }) || {};
      this.setState({ project_status: project_status._id });
      if (this.props.customer) {
        this.setState({ customer: this.props.customer });
      }
      if (this.props.project && this.props.project?.department) {
        this.setState({ department: this.props.project.department._id });
      }
      if (this.props.contract) {
        const contractType = find(codes, {
          _id: this.props.contract.contract_type._id
        });
        const callType = find(codes, {
          label: contractType.label,
          entity: "Call"
        });
        this.setState({
          contract: this.props.contract._id,
          customer: this.props.contract.customer._id,
          call_type: callType._id,
          contractStart: this.props.contract.start_date,
          contractEnd: this.props.contract.end_date
        });
      }
    } else {
      const project_status = isObject(project.project_status)
        ? project.project_status._id
        : project.project_status;

      const customer = isObject(project.customer)
        ? project.customer._id
        : project.customer;
      const contractId = isObject(project.contract)
        ? project.contract._id
        : project.contract;
      const category = isObject(project.category)
        ? project.category._id
        : project.category;

      const contract = find(this.props.contracts, { _id: contractId });

      const updates = {
        contract: contractId,
        project_status,
        customer,
        category,
        department: this.props.project.department._id,
        expected_end_date: this.props.project.expected_end_date,
        department_category: this.props.project.department_category,
        resource1: this.props.project?.resource1?._id,
        resource2: this.props.project?.resource2?._id,
        salesperson: this.props.project?.salesperson?._id,
        start_date: this.props.project?.start_date,
        end_date: this.props.project?.end_date
      };

      if (contract) {
        updates.contractStart = contract.start_date;
        updates.contractEnd = contract.end_date;
      }

      if (project.supportResources?.length) {
        updates.supportResources = project.supportResources.map((item) => ({
          employee: item.employee._id,
          text: item.order,
          id: item.order
        }));
      }

      if (project.budget_segments?.length) {
        updates.budget_segments = project.budget_segments;
        updates.monthlySegmentsChecked = true;
      }

      this.setState(updates);
    }
  };

  enableButton = () => this.setState({ canSubmit: true });

  disableButton = () => this.setState({ canSubmit: false });

  add = (model) => {
    const data = { ...model };
    if (data.start_date) {
      data.start_date = moment(data.start_date).toDate();
    }
    if (data.end_date) {
      data.end_date = moment(data.end_date).toDate();
    }
    data.department_category = this.state.department_category;
    this.props.onAdd(data);
  };

  save = (model) => {
    model.id = this.props.project._id;
    const data = { ...model };
    if (data.start_date) {
      data.start_date = moment(data.start_date).toDate();
    }
    if (data.end_date) {
      data.end_date = moment(data.end_date).toDate();
    }
    if (data.expected_end_date) {
      data.expected_end_date = moment(data.expected_end_date).toDate();
    }
    data.department_category = this.state.department_category;
    this.props.onSave(data);
  };

  cancel = () => {
    this.props.onCancel();
  };

  generateCodeOptions = (entity, field) => {
    const codeOptions = this.props.codes
      .filter((codes) => codes.entity === entity && codes.field === field)
      .map((code) => ({ value: code._id, label: code.label }));

    return orderBy(codeOptions, "label");
  };

  generateContractOptions = () => {
    const { project, contracts, customer } = this.props;
    let contractOptions;
    // if loading from specific contract page, set options to the viewed contract
    if (this.props.contract) {
      contractOptions = [
        { value: this.props.contract._id, label: this.props.contract.name }
      ];
    } else if (Array.isArray(contracts) && contracts.length) {
      contractOptions = contracts
        .filter(
          (contract) =>
            contract.contract_status?.label === "Active" &&
            contract.customer?._id ===
              (this.props.contract // if loading from contracts
                ? this.props.contract.customer._id
                : this.state.customer || // on customer field chnage
                  (project.customer && project.customer._id) || // if loading from customers
                  customer) // if loading from customers
        )
        .map((contract) => ({ value: contract._id, label: contract.name }));
    }
    return orderBy(contractOptions, "label");
  };

  generateUserOptions = () => {
    const { users } = this.props;
    const userOptions = users.map((user) => ({
      value: user._id,
      label: `${user.first_name} ${user.last_name}`
    }));

    return orderBy(userOptions, "label");
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const { project, codes } = nextProps;
    if (project !== this.props.project || codes !== this.props.codes) {
      this.loadDefaults(nextProps);
    }
  };

  handleOngoingChange = (name, value) => {
    if (value) {
      this.setState({ expected_end_date: "" });
    }
  };

  prepData = (model) => {
    delete model.employee;
    const data = {
      ...model,
      supportResources: this.state.supportResources
        .filter((item) => item.employee)
        .map((item) => ({
          employee: item.employee,
          order: parseInt(item.text)
        }))
    };
    if (this.props.adding) {
      if (this.state.monthlySegmentsChecked) {
        data.budget_segments = this.state.budget_segments.map((bs) => ({
          ...bs,
          budgetHours: parseInt(bs.budgetHours),
          created_by: this.props.auth.username
        }));
      } else {
        data.budget_segments = [];
      }
      this.add(data);
    } else {
      if (this.state.monthlySegmentsChecked) {
        if (this.state.monthlySegmentsChanged) {
          data.budget_segments = this.state.budget_segments.map((bs) => ({
            ...bs,
            budgetHours: parseInt(bs.budgetHours),
            modified_by: this.props.auth.username
          }));
        }
      } else {
        data.budget_segments = [];
      }
      this.save(data);
    }
  };

  render() {
    const { customer, project, contract, editing, adding, contracts } =
      this.props;
    const { contractStart, contractEnd } = this.state;

    const callType = this.state.call_type || project.call_type?._id;
    const showMonthlyHours = [
      "RETAINER",
      "MANAGED SERVICES",
      "CLIENTCARE"
    ].includes(this.props.codes?.find((code) => code._id === callType)?.label);

    return (
      <Formsy
        className="vertical form"
        onValidSubmit={this.prepData}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <div className="content-wrapper">
          <Row>
            <Col md={12} xs={12}>
              <fieldset>
                <legend>Project Info</legend>
              </fieldset>
            </Col>
            {!adding && (
              <Col md={4} xs={12}>
                <Input
                  name="project_number"
                  label="ID"
                  value={project.project_number}
                  disabled
                  validations={{ maxLength: 50 }}
                  validationErrors={{
                    maxLength: "You can not type in more than 50 characters"
                  }}
                />
              </Col>
            )}
            <Col md={4} xs={12}>
              <Input
                required={editing}
                name="name"
                label="Project Name"
                value={project.name}
                disabled={!editing}
                validations={{ maxLength: 150 }}
                validationErrors={{
                  maxLength: "You can not type in more than 150 characters"
                }}
              />
            </Col>
            <Col md={adding ? 8 : 4} xs={12}>
              <Input
                name="description"
                label="Project Description"
                value={project.description}
                disabled={!editing}
                validations={{ maxLength: 250 }}
                validationErrors={{
                  maxLength: "You can not type in more than 250 characters"
                }}
              />
            </Col>
            <Col md={4} xs={12}>
              <DropdownSearch
                required
                name="customer"
                label="Customer"
                disabled={!editing || contract || customer}
                onChange={this.onChange}
                value={this.state.customer}
                data={orderBy(
                  this.props.customers.map((cust) => ({
                    value: cust._id,
                    label: cust.name
                  })),
                  "label"
                )}
              />
            </Col>
            <Col md={4} xs={12}>
              <DropdownSearch
                required={adding}
                name="contract"
                loading
                label="Contract"
                isLoading={!contracts.length}
                onChange={this.onChange}
                disabled={!editing || contract}
                data={[...this.generateContractOptions()]}
                value={this.state.contract}
              />
            </Col>
            <Col md={4} xs={12}>
              <DropdownSearch
                required
                name="call_type"
                label="Call Type"
                disabled
                onChange={this.onChange}
                value={this.state.call_type || project.call_type?._id}
                data={[...this.generateCodeOptions("Call", "type")]}
              />
            </Col>
            <Col md={3} xs={12}>
              <DropdownSearch
                required
                name="project_status"
                label="Status"
                disabled={!editing}
                onChange={this.onChange}
                value={this.state.project_status}
                data={[...this.generateCodeOptions("Project", "status")]}
              />
            </Col>
            <Col md={3} xs={6}>
              <DropdownSearch
                required
                name="category"
                label="Category"
                disabled={!editing}
                onChange={this.onChange}
                value={this.state.category}
                data={[
                  ...this.generateCodeOptions("Project", "project_category")
                ]}
              />
            </Col>
            <Col md={3} xs={6}>
              <DropdownSearch
                required
                name="department"
                label="Primary Department"
                disabled={!editing}
                onChange={this.onChange}
                value={this.state.department || project.department}
                data={orderBy(
                  [
                    ...this.props.departments.map((department) => ({
                      value: department._id,
                      label: department.description
                    }))
                  ],
                  "order"
                )}
              />
            </Col>
            <Col md={3} xs={12}>
              <DepartmentCategorySelect
                isClearable
                departmentCategories={this.props.departmentCategories}
                department={this.state.department}
                label="Department Category"
                name="department_category"
                value={
                  this.state.department_category?.id ||
                  this.state.department_category
                }
                onChange={this.onChange}
              />
            </Col>
            <Col md={3} xs={6}>
              <DropdownSearch
                required
                name="project_manager"
                label="Project Manager"
                disabled={!editing}
                onChange={this.onChange}
                value={
                  this.state.project_manager ||
                  (project.project_manager && project.project_manager._id)
                }
                data={[...this.generateUserOptions()]}
              />
            </Col>
            <Col md={3} xs={6}>
              <DropdownSearch
                isClearable
                name="salesperson"
                label="Sales Person"
                disabled={!editing}
                onChange={this.onChange}
                value={this.state.salesperson}
                data={orderBy(
                  [
                    ...this.props.users
                      .filter((user) =>
                        user.roles.some((role) => role.name === "Salesperson")
                      )
                      .map((user) => ({
                        value: user._id,
                        label: `${user.first_name} ${user.last_name}`
                      }))
                  ],
                  "label"
                )}
              />
            </Col>
            <Col md={3} xs={12}>
              <DropdownSearch
                isClearable
                name="resource1"
                label="Primary Resource"
                disabled={!editing}
                onChange={this.onChange}
                value={this.state.resource1}
                data={[...this.generateUserOptions()]}
              />
            </Col>
            <Col md={3} xs={12}>
              <DropdownSearch
                isClearable
                name="resource2"
                label="Secondary Resource"
                disabled={!editing}
                onChange={this.onChange}
                value={this.state.resource2}
                data={[...this.generateUserOptions()]}
              />
            </Col>
            <Col xs={3}>
              <DatePicker
                required={editing}
                name="start_date"
                label="Start Date"
                disabled={!editing}
                onChange={this.onChangeDate}
                value={this.state.start_date || project.start_date || null}
                validations={{
                  isValidDate(values, value) {
                    return (
                      !values.end_date ||
                      moment(value).isBefore(values.end_date)
                    );
                  },
                  isValidContractDate(values, value) {
                    if (!contractStart) return true;
                    return (
                      !value ||
                      moment(value).isSameOrAfter(
                        moment(contractStart).startOf("day")
                      )
                    );
                  }
                }}
                validationErrors={{
                  isValidDate: "Start date should be before end date",
                  isValidContractDate:
                    "Start date should be within contract dates"
                }}
              />
            </Col>
            <Col xs={3}>
              <DatePicker
                type="date"
                name="end_date"
                label="End Date"
                disabled={!editing}
                onChange={this.onChangeDate}
                value={this.state.end_date || project.end_date || null}
                validations={{
                  isValidDate(values, value) {
                    return !value || moment(value).isAfter(values.start_date);
                  },
                  isValidContractDate(values, value) {
                    if (!contractEnd) return true;
                    return (
                      !value ||
                      moment(value).isSameOrBefore(
                        moment(contractEnd).endOf("day")
                      )
                    );
                  }
                }}
                validationErrors={{
                  isValidDate: "End date should be after start date",
                  isValidContractDate:
                    "End date should be within contract dates"
                }}
              />
            </Col>
            <Col xs={3}>
              <DatePicker
                type="date"
                name="expected_end_date"
                label="Expected End Date"
                disabled={!editing}
                onChange={this.onChangeDate}
                value={this.state.expected_end_date}
                validations={{
                  isValidDate(values, value) {
                    return !value || moment(value).isAfter(values.start_date);
                  },
                  isValidContractDate(values, value) {
                    if (!contractEnd) return true;
                    return (
                      !value ||
                      moment(value).isSameOrBefore(
                        moment(contractEnd).endOf("day")
                      )
                    );
                  }
                }}
                validationErrors={{
                  isValidDate: "End date should be after start date",
                  isValidContractDate:
                    "End date should be within contract dates"
                }}
              />
            </Col>
            <Col xs={3}>
              <Checkbox
                name="ongoing"
                valueLabel="Ongoing"
                value={
                  typeof this.state.expected_end_date !== "undefined"
                    ? !this.state.expected_end_date
                    : !project.expected_end_date
                }
                disabled={!editing || !this.state.expected_end_date}
                onChange={this.handleOngoingChange}
              />
            </Col>
          </Row>
          <Row>
            <ProjectBudgetCalculator
              editing={editing}
              defaultBillingRate={this.state.rate}
              inputs={adding ? this.state : project}
              adding={adding}
              showMonthlyHours={showMonthlyHours}
              setState={(obj) => this.setState(obj)}
            />
            <Col md={3}>
              <Checkbox
                name="requestor_required"
                valueLabel="Requestor Required"
                value={
                  this.state.requestor_required || project.requestor_required
                }
                disabled={!editing}
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <SupportResources
                resources={this.state.supportResources}
                onChange={this.onChange}
                onChangeSupportResources={this.onChangeSupportResources}
                ticketAssignmentStyle={
                  this.state.ticketAssignmentStyle ||
                  project.ticketAssignmentStyle?._id
                }
                ticketAssignmentStyleOptions={this.generateCodeOptions(
                  "Project",
                  "assignment_type"
                )}
                employeeOptions={this.generateUserOptions()}
                isNightMode={this.props.auth.isNightMode}
              />
            </Col>
            <Col md={6}>
              <MonthlySegmentForm
                data={this.state.budget_segments}
                startDate={moment(this.state?.start_date)?.toDate()}
                endDate={moment(this.state?.end_date)?.toDate()}
                onSegmentsChange={this.onChangeMonthlySegments}
                dateHasChanged={this.state.dateHasChanged}
                isNightMode={this.props.auth.isNightMode}
              />
            </Col>
          </Row>
          <Row>
            <Col md={12} className="footer">
              <button
                className="btn  btn-cancel"
                type="button"
                onClick={this.cancel}
              >
                Cancel
              </button>
              {typeof this.props.saving !== "undefined" && (
                <React.Fragment>
                  {!this.props.adding && (
                    <input
                      className="btn btn-success"
                      type="submit"
                      disabled={
                        !this.state.canSubmit ||
                        this.props.preventEdit ||
                        this.props.saving
                      }
                      value={this.props.saving ? "Saving... " : "Save"}
                    />
                  )}
                  {this.props.adding && (
                    <input
                      className="btn btn-success"
                      type="submit"
                      disabled={!this.state.canSubmit || this.props.saving}
                      value={this.props.saving ? "Adding... " : "Add"}
                    />
                  )}
                </React.Fragment>
              )}
            </Col>
          </Row>
        </div>
      </Formsy>
    );
  }
}

ProjectForm.propTypes = {
  saving: PropTypes.bool,
  onSave: PropTypes.func,
  codes: PropTypes.array,
  project: PropTypes.object,
  onCancel: PropTypes.func,
  editing: PropTypes.bool,
  adding: PropTypes.bool,
  onAdd: PropTypes.func,
  customer: PropTypes.object,
  contract: PropTypes.object,
  preventEdit: PropTypes.bool,
  departments: PropTypes.array,
  users: PropTypes.array,
  customers: PropTypes.array,
  actions: PropTypes.array,
  contracts: PropTypes.array,
  departmentCategories: PropTypes.array,
  auth: PropTypes.object
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    customers: state.reducers.customers,
    departments: state.reducers.departments,
    users: state.reducers.users,
    contracts: state.reducers.contracts,
    codes: state.reducers.codes,
    departmentCategories: state.reducers.departmentCategories,
    auth: state.reducers.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...contractActions,
        ...departmentActions,
        ...userActions,
        ...codeActions,
        ...customerActions,
        ...departmentCategoryActions
      },
      dispatch
    )
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(ProjectForm);
